import React, { useState } from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';

const ButtonSimple = (props) => {
    const [isHover, setIsHover] = useState(false);
    const isDisabled = props.loading || props.disabled === true || props.disabled === 'true';

    return (
        <button
            type="button"
            disabled={isDisabled}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            className={`${props.classes} w-[100px] flex items-center transition duration-300 ${isDisabled ? 'bg-zinc-300 text-white-100 cursor-not-allowed' : 'cursor-pointer'} justify-center relative hover:opacity-80 outline-none rounded-lg`}
            onClick={isDisabled ? undefined : props.click}
        >
            {props.loading ? (
                <ScaleLoader height={20} width={3} color={isHover ? '#FFC20E' : '#374151'} size={5} />
            ) : (
                props.children
            )}
        </button>
    );
};

export default ButtonSimple;
